var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "el-tooltip",
    {
      staticClass: "c-ellipsis-tooltip",
      attrs: {
        "popper-class": _vm.isAddPopperClass ? "tb-dialog-popover" : "",
        content: _vm.getTooltipContent(),
        disabled: !_vm.isOverflow,
        placement: "top",
        effect: "dark"
      }
    },
    [
      _c(
        "div",
        {
          ref: "content",
          staticClass: "clamped-text",
          style: _vm.contentStyle,
          on: { mouseenter: _vm.handleMouseenter, click: _vm.handleClick }
        },
        [_vm._v(" " + _vm._s(_vm.text ? _vm.text : "-") + " ")]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }